import IAddressVm from "./IAddressVm"
import { CompanyCreateType } from "./../enums/CompanyCreateType"

import * as IAddressVmInstance from "./IAddressVm"

export default interface ICompanyVm {
    id?: string
    companyRegistrationIdentifier: string
    name: string
    phone: string
    email: string
    address: IAddressVm
    electronicInvoiceNumber: string
    reference: string
    associatedEducationalInstitutionId?: string
    companyCreateType: CompanyCreateType
    isActive: boolean
}

export const empty = (enableIteration: boolean = true): ICompanyVm => {
	return {
		id: "",
		companyRegistrationIdentifier: "",
		name: "",
		phone: "",
		email: "",
		address: IAddressVmInstance.empty(),
		electronicInvoiceNumber: "",
		reference: "",
		associatedEducationalInstitutionId: "",
		companyCreateType: CompanyCreateType.NotSet,
		isActive: false
	} as ICompanyVm
}